<template>
  <v-col class="about pa-0 ma-0">
    <!-- <h1>This is an about page</h1> -->
    <grid-1/>
    <grid-2/>
  </v-col>
</template>

<script>
import Grid1 from '../components/pages/about/Grid1.vue'
import Grid2 from '../components/pages/about/Grid2.vue'
export default {
  components: { Grid1, Grid2 },

}
</script>

<style>

</style>